import type { ActivityOverviewSupportDto } from '../../../../core/api/FitnessActivityClient';

export const formatDayCardDate = (date: Date) =>
    date.toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });

export const hasDailySteps = (data: ActivityOverviewSupportDto | null) =>
    Boolean(data?.dailySteps?.length);

export const hasTimeframeData = (data: ActivityOverviewSupportDto | null) =>
    Boolean(
        data?.activityPointsChanges?.length ||
            data?.facilityVisits?.length ||
            data?.workouts?.length
    );

export const hasGpxData = (data: ActivityOverviewSupportDto | null) =>
    Boolean(data?.facilityVisits && data?.workouts);
